<div class="outerWrapper">
  <div class="innerWrapper">
    <h3 class="header">{{selText.login}}</h3>
    <div class="dividerRight"></div>
    <div class="dividerLeft"></div>
    <div class="loginLogosWrapper">
      <img src="assets/images/islandis.png" alt="" style="width: 96%;"
        (click)="loginWithIsland()" class="loginLogo" [class.disabledLogin]="islandLoginAllowed === false">
      <img src="assets/images/btn_google_signin_light_normal_web@2x.png" alt="" class="loginLogo loginLogoNoShadow"
        (click)="loginWithGoogle()" [class.disabledLogin]="googleLoginAllowed === false">
    </div>
    <div class="LMILoginWrapper" [class.disabledLogin]="lmiLoginAllowed === false">
      <div class="LMILogoWrapper">
        <img src="https://mapview.gis.is/logo/NATT-logo-notext-400x361.png" class="LMILogo" alt="">
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{selText.username}}: </mat-label>
        <input [readonly]="!lmiLoginAllowed" matInput [formControl]="username">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{selText.password}}: </mat-label>
        <input [readonly]="!lmiLoginAllowed" matInput [type]="passwordFieldType" [formControl]="password">
        <button mat-icon-button matSuffix tabindex="-1" (click)="togglePasswordVisibility($event)"
          [attr.aria-label]="passwordFieldType === 'password' ? selText.showPassword : selText.hidePassword"
          matTooltip="{{ passwordFieldType === 'password' ? selText.showPassword : selText.hidePassword }}">
          <mat-icon>{{ passwordFieldType === 'text' ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
      <div class="loginButtonWrapper">
        <button mat-raised-button color="primary" class="loginButton" (click)="loginWithLMI()">{{selText.login}}</button>
      </div>
    </div>
    @if (failedLogin) {
      <div id="credentialsMessage">
        <h6>{{selText.wrongCredentials}}</h6>
      </div>
    }
    <div id="cancelButton">
      @if (!loginRequired) {
        <button mat-raised-button color="warn" (click)="cancelLogin()">
          {{selText.cancel}}
        </button>
      }
    </div>
  </div>
</div>